/**
 * Leaves the app for Stripe's hosted Checkout page.
 *
 * Its own module so tests can replace it (jsdom cannot navigate), and so the one place that sends
 * the browser off-site refuses anything that is not https.
 */
export const redirectToCheckout = (checkoutUrl: string): void => {
  let url: URL;
  try {
    url = new URL(checkoutUrl);
  } catch {
    throw new Error('Invalid checkout URL');
  }
  if (url.protocol !== 'https:') {
    throw new Error('Refusing a non-https checkout URL');
  }
  window.location.assign(url.toString());
};
